// extracted by mini-css-extract-plugin
module.exports = {"svRed":"#f3232f","svBlack":"#1d1c28","svGray":"#babec0","svBlue":"#244393","svMatchGreen":"#32cd32","svMatchYellow":"#cc0","svMatchRed":"#f3232f"};